export default {
  name: 'loading',
  destroyed: function destroyed() {
    /* 我们自己手动注册的事件应该手动的销毁 */
    document.body.removeChild(this.$el);
  }
};